module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/resized/truora-logo-052ab24061980035813409e98b315e0d.svg";